// pages/Dashboard.jsx
import OrderConfirmationPage from "../../components/home/orderComponents/OrderConfirmationPage";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <OrderConfirmationPage />
    </HomeLayout>
  );
}
